import axios from 'axios'
import { delete_candidates } from '../settingSlice'

async function create_template(dispatch,token,assessments,add_assessment,add_assessments,setOpen,setMessage,data,setLoading,navigate){
try {
    setLoading(true)

    const addAssessm = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}add-assessment/`,data,{
         headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${token}`
            }
     }).catch(err=>{console.log(err)})

    if (addAssessm?.status == 200 && addAssessm?.data?.success) {

        await dispatch(add_assessment(addAssessm?.data.assessment))
        await dispatch(delete_candidates())
        localStorage.setItem("iTest_assessment",JSON.stringify(addAssessm?.data?.assessment))

        setMessage("Assessment created")
        setOpen(true)
        setLoading(false)
        navigate("/assessmentInfo")

    }else{
      setMessage(addAssessm?.data?.message)
      setOpen(true)
      setLoading(false)
    }
} catch (error) {
    console.log(error)
}

}

export default create_template